import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  //agentId: null,
  //mode: null,
  //agentState: null,
  error: null,
  loading: false,
  status: null,
};

const modeChangeStart = (state, action) => {
  return updateObject(state, {loading: true, status: 'Success' });
};

const modeChangeSuccess = (state, action) => {
  return updateObject(state, {
    agentId: action.agentId,
    mode: action.mode,
    agentState: action.agentState,
    error: null,
    loading: false,
    status: 'Success',
  });
};

const modeUpdate = (state, action) => {
  return updateObject(state, {
    agentId: action.agentId,
    mode: action.mode,
    agentState: action.agentState,
    error: null,
    loading: false,
    status: 'Success',
  });
};

const modeChangeFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false, status: false,});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AGENT_MODE_CHANGE_START:
      return modeChangeStart(state, action);
    case actionTypes.AGENT_MODE_CHANGE_SUCCESS:
      return modeChangeSuccess(state, action);
    case actionTypes.AGENT_MODE_CHANGE_FAIL:
      return modeChangeFail(state, action);
    case actionTypes.AGENT_MODE_UPDATE:
      return modeUpdate(state, action);
    default:
      return state;
  }
};

export default reducer;
